import { setDefaultLocale } from 'react-datepicker';
import { setDefaultOptions } from 'date-fns';
import I18n from 'i18n-js';

import { setApiLanguage } from '@lootboy/lib';
import { LANGUAGES } from '@lootboy/translations/config';
import currency from '@lootboy/translations/currency';
import en from '@lootboy/translations/en';

// Enable fallbacks if you want `en-US` and `en-GB` to fallback to `en`
I18n.fallbacks = true;
[I18n.defaultLocale] = LANGUAGES;

I18n.missingTranslation = (message) => message;

const getTranslationsAsync = {
  de: async () => import('@lootboy/translations/de'),
  fr: async () => import('@lootboy/translations/fr'),
  es: async () => import('@lootboy/translations/es'),
};

const getDateLocaleAsync = {
  de: async () => import('date-fns/locale/de'),
  fr: async () => import('date-fns/locale/fr'),
  es: async () => import('date-fns/locale/es'),
};

I18n.locale = (() => {
  let language;
  if (
    Array.isArray(navigator.languages) &&
    navigator.languages.length > 0 &&
    navigator.languages[0]
  ) {
    [language] = navigator.languages;
  } else if (navigator.language) {
    language = navigator.language;
  } else if (navigator.browserLanguage) {
    language = navigator.browserLanguage;
  } else if (navigator.userLanguage) {
    language = navigator.userLanguage;
  }

  if (LANGUAGES.indexOf(language) !== -1) {
    return language;
  }

  return (
    LANGUAGES.find((lang) => language.indexOf(`${lang}-`) === 0) ||
    I18n.defaultLocale
  );
})();

setApiLanguage(I18n.locale);

I18n.translations = {
  en,
};

Object.keys(currency).forEach((lang) => {
  if (I18n.translations[lang]) {
    I18n.translations[lang].number = {
      currency: { format: currency[lang] },
    };
  }
});

export async function loadTranslationAsynchronously(lang) {
  const languageCode = typeof lang === 'string' && lang.slice(0, 2);
  if (!languageCode || I18n.translations[languageCode]) {
    return;
  }
  if (getTranslationsAsync[languageCode]) {
    await getTranslationsAsync[languageCode]()
      .then(({ default: translations }) => {
        I18n.translations[languageCode] = translations;
        if (currency[languageCode]) {
          I18n.translations[languageCode].number = {
            currency: { format: currency[languageCode] },
          };
        }
      })
      .catch(() => {});
  }
  if (getDateLocaleAsync[languageCode]) {
    await getDateLocaleAsync[languageCode]()
      .then(({ default: locale }) => setDefaultOptions({ locale }))
      .catch(() => {});
  }
}

loadTranslationAsynchronously(I18n.locale).catch(() => {});
setDefaultLocale(I18n.locale);

export default {
  loadTranslationAsynchronously,
};
